import React from "react";
import RowWrapper from "../../shared/bootstrap/RowWrapper.jsx";
import HeaderSearch from "../../shared/HeaderSearch.jsx";
import ContractHoldersHeaderGroupTypeOptions from "../HeaderGroupTypeOptions.jsx";

export default function Header({
  contractHoldersGroups,
  options,
  setOptions,
  searchType,
  setSearchType,
  searchValue,
  setSearchValue,
}) {
  return (
    <>
      <h1 className="page_title" role="banner" tabIndex="-1">
        NASA SEWP Program Managers and Deputy Program Managers Names and Numbers
      </h1>
      <RowWrapper>
        <div className="col-sm-7" title="help text">
          <ul>
            <li>Select the Company Name to display the detailed information page for the specified Contract Holder.</li>
            <li>
              Select the column heading 'ContractHolder', 'Name' or 'Email' to sort the table by that column - select it
              again to reverse the sort.
            </li>
            <li>
              Enter text in the search field to search within the table. Select from the radio buttons above the field
              to restrict your search. Select clear search to clear the search field.
            </li>
          </ul>
        </div>
        <HeaderSearch
          searchType={searchType}
          setSearchType={setSearchType}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
      </RowWrapper>
      <RowWrapper id="filtergroup">
        <ContractHoldersHeaderGroupTypeOptions
          contractHoldersGroups={contractHoldersGroups}
          options={options}
          setOptions={setOptions}
        />
      </RowWrapper>
    </>
  );
}
